import { createAsyncThunk } from '@reduxjs/toolkit';

import api, { DocPayload, AppDocument, AxiosError } from 'api';

export const loadDoc = createAsyncThunk(
    'GET/document-properties/{app_id}/{doc_id}',
    async ({ appID, docID }: { appID: string; docID: string }, { rejectWithValue }) => {
        try {
            return await api.documentProperties.get(appID, docID);
        } catch (e) {
            return rejectWithValue((e as AxiosError).response?.data);
        }
    }
);

export const updateDoc = createAsyncThunk(
    'api/document-properties/{app_id}/{doc_id}(PUT)',
    async ({ appId, docId, payload }: { appId: string; docId: string; payload: DocPayload }) =>
        await api.documentProperties.put(appId, docId, payload)
);

export const createNewDocProperties = createAsyncThunk(
    'api/document-properties/{app_id}/{doc_id}(POST)',
    async ({ appId, payload }: { appId: string; payload: DocPayload }) =>
        await api.documentProperties.post(appId, payload)
);

//! Remove document only without attached file
export const deleteDoc = createAsyncThunk(
    'DELETE/document-properties/{app_id}/{doc_id}',
    async ({ appID, docID }: { appID: string; docID: string }) =>
        await api.documentProperties.del(appID, docID)
);

//! Remove document properties and attached file (can't delete doc without attached file)
export const deleteAttachedDocFile = createAsyncThunk(
    'DELETE/document-resource/{doc_id}',
    async (docID: string) => await api.documentResource.del(docID)
);

export const patchDocProperty = createAsyncThunk(
    'PATCH/document-properties/{app_id}/{doc_id}',
    async (
        {
            appID,
            docID,
            payload,
        }: {
            appID: string;
            docID: string;
            payload: { [key in keyof AppDocument]?: AppDocument[key] };
        },
        { rejectWithValue }
    ) => {
        try {
            return await api.documentProperties.patch(appID, docID, payload);
        } catch (e) {
            return rejectWithValue((e as AxiosError).response?.data);
        }
    }
);
